module.exports = __webpack_public_path__ + "img/sprite.e38a55a2.png";